import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectToCanva } from '../components';

export const routes = <Route path="/canva/authorize" element={<ConnectToCanva />} />;
